import { useDispatch } from "react-redux";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";
import Grid from "@mui/material/Grid";
import { Set_bin_HeadObject_Set } from "../Slicebin";
import { CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
export default function GCHead({
  //grid saleshistory end
  vRdxWmsHead,
  xKey, 
  xErrorMsg,
  sAttribute
}) {
  const dispatch = useDispatch();
  return (
    <form id="binHead">
      <Grid
        container
        rowSpacing={{ xs: 1, sm: 1, md: 1 }}
        columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        marginTop={{xs:7, sm:0, md:0}}
      >
        <Grid item xs={12} sm={12} md={6}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            
            <Grid item xs={6} sm={4} md={6}  >
              <CmpTextFieldV1
                              xLabelText="Code"
                xValue={vRdxWmsHead.Code}
                xType={"text"} // text/number/password
                xName={"Code"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.Code === "" ? false : true}
                xErrorMessage={xErrorMsg.Code}
                xOnKeyUp={xKey}
              />
            </Grid>
           
            <Grid item xs={6} sm={4} md={6}   className="d-flex">
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Aisle"
                xValue={vRdxWmsHead.Aisle}
                xOnChange={(e) => {
                  dispatch(
                    Set_bin_HeadObject_Set({
                      ...vRdxWmsHead,
                      Aisle: e.target.value, 
                    })
                  );
                }}
                xName={"Aisle"}
                xData={sAttribute?.aisle}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Aisle === "" ? false : true}
                xErrorMessage={xErrorMsg.Aisle}
                xDisable={false}
                // xOnKeyUp={xKey}
              />
              
            </Grid>
           
            <Grid item xs={6} sm={4} md={6}   className="d-flex">
              
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Level"
                xValue={vRdxWmsHead.Level}
                xOnChange={(e) => {
                  dispatch(
                    Set_bin_HeadObject_Set({
                      ...vRdxWmsHead,
                      Level: e.target.value, 
                    })
                  );
                }}
                xName={"Level"}
                xData={sAttribute?.level}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Level === "" ? false : true}
                xErrorMessage={xErrorMsg.Level}
                xDisable={false}
                // xOnKeyUp={xKey}
              />
            </Grid>
            
            <Grid item xs={6} sm={4} md={6}  >
               <CmpTextFieldV1
                        xLabelText="ShortDesc"
                xValue={vRdxWmsHead.ShortDesc}
                xType={"text"} // text/number/password
                xName={"ShortDesc"}
                xReadOnly={false}
                xOnChange={(e)=>{
                  dispatch(
                    Set_bin_HeadObject_Set({
                      ...vRdxWmsHead,
                      ShortDesc: e.target.value, 
                    })
                  );
                }}
                xError={xErrorMsg.ShortDesc === "" ? false : true}
                xErrorMessage={xErrorMsg.ShortDesc}
                xOnKeyUp={xKey}
              />
            </Grid>
          
            <Grid item xs={6} sm={4} md={6}  >
               <CmpTextFieldV1
                        xLabelText="Desc"
                xValue={vRdxWmsHead.Desc}
                xType={"text"} // text/number/password
                xName={"Desc"}
                xReadOnly={false}
                xOnChange={(e)=>{
                  dispatch(
                    Set_bin_HeadObject_Set({
                      ...vRdxWmsHead,
                      Desc: e.target.value, 
                    })
                  );
                }}
                xError={xErrorMsg.Desc === "" ? false : true}
                xErrorMessage={xErrorMsg.Desc}
                xOnKeyUp={xKey}
              />
            </Grid>
          
            <Grid item xs={6} sm={4} md={6}  >
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Loc"
                xValue={vRdxWmsHead.Loc}
                xOnChange={(e)=>{
                  dispatch(
                    Set_bin_HeadObject_Set({
                      ...vRdxWmsHead,
                      Loc: e.target.value, 
                    })
                  );
                }}
                xName={"Loc"}
                xData={sAttribute?.Location}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Loc === "" ? false : true}
                xErrorMessage={xErrorMsg.Loc}
                xDisable={false}
                // xOnKeyUp={xKey}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Grid
            container
            spacing={0.9}
            columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={12} sm={12} md={6}>
              <Grid
                container
                spacing={0.9}
                columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                className={
                  hasValueInErrorMessage(xErrorMsg)
                    ? "align-items-center"
                    : "align-items-start"
                }
              >
                 
                <Grid item xs={6} sm={3} md={6}  >
                    <CmpTextFieldV1
                    xLabelText="Length"
                    xValue={vRdxWmsHead.Length}
                    xType={"text"} // text/number/password
                    xName={"Length"}
                    xReadOnly={false}
                    xOnChange={(e)=>{
                      dispatch(
                        Set_bin_HeadObject_Set({
                          ...vRdxWmsHead,
                          Length: e.target.value, 
                        })
                      );
                    }}
                    xError={xErrorMsg.Length === "" ? false : true}
                    xErrorMessage={xErrorMsg.Length}
                    xOnKeyUp={xKey}
                  />
                </Grid>
                
                <Grid item xs={6} sm={3} md={6}  >
                    <CmpTextFieldV1
                        xLabelText="Width"
                    xValue={vRdxWmsHead.Width}
                    xType={"text"} // text/number/password
                    xName={"Width"}
                    xReadOnly={false}
                    xOnChange={(e)=>{
                      dispatch(
                        Set_bin_HeadObject_Set({
                          ...vRdxWmsHead,
                          Width: e.target.value, 
                        })
                      );
                    }}
                    xError={xErrorMsg.Width === "" ? false : true}
                    xErrorMessage={xErrorMsg.Width}
                    xOnKeyUp={xKey}
                  />
                </Grid>
              
                <Grid item xs={6} sm={3} md={6}  >
                  <CmpTextFieldV1
                    xLabelText="Height"
                    xValue={vRdxWmsHead.Height}
                    xType={"text"} // text/number/password
                    xName={"Height"}
                    xReadOnly={false}
                    xOnChange={(e)=>{
                      dispatch(
                        Set_bin_HeadObject_Set({
                          ...vRdxWmsHead,
                          Height: e.target.value, 
                        })
                      );
                    }}
                    xError={xErrorMsg.Height === "" ? false : true}
                    xErrorMessage={xErrorMsg.Height}
                    xOnKeyUp={xKey}
                  />
                </Grid>
              
                <Grid item xs={6} sm={3} md={6}  >
                   <CmpTextFieldV1
                        xLabelText="CBM"
                    xValue={vRdxWmsHead.CBM}
                    xType={"text"} // text/number/password
                    xName={"CBM"}
                    xReadOnly={true}
                    xOnChange={(e)=>{
                      dispatch(
                        Set_bin_HeadObject_Set({
                          ...vRdxWmsHead,
                          CBM: e.target.value, 
                        })
                      );
                    }}
                    xError={xErrorMsg.CBM === "" ? false : true}
                    xErrorMessage={xErrorMsg.CBM}
                    xOnKeyUp={xKey}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <Grid
                container
                spacing={0.9}
                columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                className={
                  hasValueInErrorMessage(xErrorMsg)
                    ? "align-items-center"
                    : "align-items-start"
                }
              >
                
                <Grid item xs={6} sm={3} md={6} >
                <CmpTextFieldV1
                    xLabelText="LengthWastage"
                    xValue={vRdxWmsHead.LengthWastage}
                    xType={"text"} // text/number/password
                    xName={"LengthWastage"}
                    xReadOnly={false}
                    xOnChange={(e)=>{
                      dispatch(
                        Set_bin_HeadObject_Set({
                          ...vRdxWmsHead,
                          LengthWastage: e.target.value, 
                        })
                      );
                    }}
                    xError={xErrorMsg.LengthWastage === "" ? false : true}
                    xErrorMessage={xErrorMsg.LengthWastage}
                    xOnKeyUp={xKey}
                  />
                </Grid>
               
                <Grid item xs={6} sm={3} md={6} >
                <CmpTextFieldV1
                    xLabelText="WidthWastage"
                    xValue={vRdxWmsHead.WidthWastage}
                    xType={"text"} // text/number/password
                    xName={"WidthWastage"}
                    xReadOnly={false}
                    xOnChange={(e)=>{
                      dispatch(
                        Set_bin_HeadObject_Set({
                          ...vRdxWmsHead,
                          WidthWastage: e.target.value, 
                        })
                      );
                    }}
                    xError={xErrorMsg.WidthWastage === "" ? false : true}
                    xErrorMessage={xErrorMsg.WidthWastage}
                    xOnKeyUp={xKey}
                  />
                </Grid>
               
                <Grid item xs={6} sm={3} md={6} >
                  <CmpTextFieldV1
                    xLabelText="HeightWastage"
                    xValue={vRdxWmsHead.HeightWastage}
                    xType={"text"} // text/number/password
                    xName={"HeightWastage"}
                    xReadOnly={false}
                    xOnChange={(e)=>{
                      dispatch(
                        Set_bin_HeadObject_Set({
                          ...vRdxWmsHead,
                          HeightWastage: e.target.value, 
                        })
                      );
                    }}
                    xError={xErrorMsg.HeightWastage === "" ? false : true}
                    xErrorMessage={xErrorMsg.HeightWastage}
                    xOnKeyUp={xKey}
                  />
                </Grid>
                
                <Grid item xs={6} sm={3} md={6} >
             <CmpTextFieldV1
                        xLabelText="NoOfPallet"
                    xValue={vRdxWmsHead.NoOfPallet}
                    xType={"text"} // text/number/password
                    xName={"NoOfPallet"}
                    xReadOnly={false}
                    xOnChange={(e)=>{
                      dispatch(
                        Set_bin_HeadObject_Set({
                          ...vRdxWmsHead,
                          NoOfPallet: e.target.value, 
                        })
                      );
                    }}
                    xError={xErrorMsg.NoOfPallet === "" ? false : true}
                    xErrorMessage={xErrorMsg.NoOfPallet}
                    xOnKeyUp={xKey}
                  />
                </Grid>
              </Grid>
            </Grid>
           
            <Grid item xs={6} sm={6} md={4}  >
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Type"
                xValue={vRdxWmsHead.Type}
                xOnChange={(e)=>{
                  dispatch(
                    Set_bin_HeadObject_Set({
                      ...vRdxWmsHead,
                      Type: e.target.value, 
                    })
                  );
                }}
                xName={"Type"}
                xData={sAttribute?.binType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Type === "" ? false : true}
                xErrorMessage={xErrorMsg.Type}
                xDisable={false}
                // xOnKeyUp={xKey}
              />
            </Grid>
          
            <Grid item xs={6} sm={6} md={4}  >
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="BinSize"
                xValue={vRdxWmsHead?.BinSize}
                xOnChange={(e)=>{
                  dispatch(
                    Set_bin_HeadObject_Set({
                      ...vRdxWmsHead,
                      BinSize: e.target.value, 
                    })
                  )
                }}
                xName={"BinSize"}
                xData={sAttribute?.binSize}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.BinSize === "" ? false : true}
                xErrorMessage={xErrorMsg.BinSize}
                xDisable={false}
                // xOnKeyUp={xKey}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
